module.exports = __webpack_public_path__ + "allen-ajax-loader.gif";